import React from "react";
import { Badge } from "antd";
import useSearchContext from "../../../hooks/useSearchContext";
import ShowCount from "./ShowCount";
const DashboardTabs = ({
  headerFilterStatus,
  count,
  setHeaderFilterStatusHandler,
  reminders,
  tabLayout,
}) => {
  const {
    newCount,
    inProcessCount,
    hiredCount,
    rejectedCount,
    onHoldCount,
    talentpoolCount,
    setHeaderFilterStatus,
  } = useSearchContext();

  if (tabLayout === "Application_Received") {
    return (
      <>
        <div className="filter-btn d-flex">
          <button
            className={`rounded-top border-0 position-relative ${
              headerFilterStatus === "Application_Received"
                ? "outline-none custom-bottom-arrow text-white active-color active-padding"
                : ""
            }`}
            onClick={() => {
              setHeaderFilterStatusHandler("Application_Received",1);
              setHeaderFilterStatus("Application_Received");
              localStorage.setItem("headerFilterStatus","Application_Received")
            }}
          >
            {headerFilterStatus === "Application_Received" && (
              <Badge
                className="badge_position"
                count={<ShowCount count={count?.totalCount || newCount} />}
                showZero
              />
            )}
            New {newCount > 0 ? `(${newCount})` : ""}
          </button>
          {/* </div> */}
          {/* <button
            className={`rounded-top border-0 position-relative ${
              headerFilterStatus === "BulkUpload"
                ? "outline-none text-white active-color active-padding"
                : ""
            }`}
            onClick={() => {
              setHeaderFilterStatusHandler("BulkUpload");
            }}
          >
            {headerFilterStatus === "BulkUpload" && (
              <Badge
                className="badge_position"
                count={count}
                overflowCount={999}
                showZero
              />
            )}
            Uploaded Data
          </button> */}
          <button
            className={`rounded-top border-0 position-relative ${
              headerFilterStatus === "In_Process"
                ? "outline-none custom-bottom-arrow text-white active-color active-padding"
                : ""
            }`}
            onClick={() => {
              setHeaderFilterStatus("In_Process");
              setHeaderFilterStatusHandler("In_Process",1);
              localStorage.setItem("headerFilterStatus","In_Process")
            }}
          >
            {headerFilterStatus === "In_Process" && (
              <Badge
                className="badge_position"
                count={<ShowCount count={count?.totalCount} />}
                showZero
              />
            )}
            In Process {inProcessCount > 0 ? `(${inProcessCount})` : ""}
          </button>
          <button
            className={`rounded-top border-0 position-relative ${
              headerFilterStatus === "Reminder"
                ? "outline-none text-white active-color active-padding"
                : ""
            }`}
            onClick={() => {
              setHeaderFilterStatus("Reminder");
              setHeaderFilterStatusHandler("Reminder",1);
              localStorage.setItem("headerFilterStatus","Reminder")
            }}
          >
            {headerFilterStatus === "Reminder" && (
              <Badge
                className="badge_position"
                count={<ShowCount count={reminders?.interviewLogsCount} />}
                showZero
              />
            )}
            Reminder
          </button>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="filter-btn d-flex">
          {tabLayout === "Hired" && (
            <button
              className={`rounded-top border-0 position-relative ${
                tabLayout === "Hired"
                  ? "outline-none text-white active-color active-padding"
                  : ""
              }`}
              onClick={() => {
                setHeaderFilterStatus("Hired");
                setHeaderFilterStatusHandler("Hired",1);
                localStorage.setItem("headerFilterStatus","Hired")
              }}
            >
              {tabLayout === "Hired" && (
                <Badge
                  className="badge_position"
                  count={<ShowCount count={count?.totalCount || hiredCount} />}
                  showZero
                />
              )}
              Hired
            </button>
          )}
          {tabLayout === "On Hold" && (
            <button
              className={`rounded-top border-0 position-relative ${
                tabLayout === "On Hold"
                  ? "outline-none text-white active-color active-padding"
                  : ""
              }`}
              onClick={() => {
                setHeaderFilterStatus("On Hold");
                setHeaderFilterStatusHandler("On Hold",1);
                localStorage.setItem("headerFilterStatus","On Hold")
              }}
            >
              {tabLayout === "On Hold" && (
                <Badge
                  className="badge_position"
                  count={<ShowCount count={count?.totalCount || onHoldCount} />}
                  showZero
                />
              )}
              On Hold
            </button>
          )}
          {tabLayout === "Rejected" && (
            <button
              className={`rounded-top border-0 position-relative ${
                tabLayout === "Rejected"
                  ? "outline-none text-white active-color active-padding"
                  : ""
              }`}
              onClick={() => {
                setHeaderFilterStatus("Rejected");
                setHeaderFilterStatusHandler("Rejected",1);
                localStorage.setItem("headerFilterStatus","Rejected")
              }}
            >
              {tabLayout === "Rejected" && (
                <Badge
                  className="badge_position"
                  count={<ShowCount count={count?.totalCount || rejectedCount} />}
                  showZero
                />
              )}
              Rejected
            </button>
          )}
          {tabLayout === "TalentPool" && (
            <button
              className={`rounded-top border-0 position-relative ${
                tabLayout === "TalentPool"
                  ? "outline-none text-white active-color active-padding"
                  : ""
              }`}
              onClick={() => {
                setHeaderFilterStatus("TalentPool");
                setHeaderFilterStatusHandler("TalentPool",1);
                localStorage.setItem("headerFilterStatus","TalentPool")
              }}
            >
              {tabLayout === "TalentPool" && (
                <Badge
                  className="badge_position"
                  count={<ShowCount count={count?.totalCount || talentpoolCount} />}
                  showZero
                />
              )}
              Talent Pool
            </button>
          )}
        </div>
      </>
    );
  }
};

export default DashboardTabs;
